import { __values } from "tslib";
import getObjectKeys from '../jsUtils/getObjectKeys';
function nativeClone(source, existingObj) {
    return Object.assign(existingObj || {}, source);
}
function customClone(source, existingObj) {
    var e_1, _a;
    var result = existingObj || {};
    if (source) {
        try {
            for (var _b = __values(getObjectKeys(source)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var key = _c.value;
                result[key] = source[key];
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
    return result;
}
// @ts-ignore Ignore this error for IE compatibility
var cloneObjectImpl = Object.assign ? nativeClone : customClone;
/**
 * @internal
 */
export function cloneObject(source, existingObj) {
    return cloneObjectImpl(source, existingObj);
}
//# sourceMappingURL=cloneObject.js.map